export default __webpack_public_path__ + "static/media/garde_corps_7.41b2b193.png";